
import '../App.css';

function Landing() {
    return (
        <div class="Landing">
            
            <a href="/menu"><div class="airB"><div class="button5">A</div>AIR BEAN<br/>
            <div class="droneD">DRONEDELIVERED COFFEE</div></div></a>
        </div>

    )
}
export default Landing;